import { render, staticRenderFns } from "./ProgramsTable.vue?vue&type=template&id=664a018c&scoped=true&"
import script from "./ProgramsTable.vue?vue&type=script&lang=js&"
export * from "./ProgramsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsTable.vue?vue&type=style&index=0&id=664a018c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a018c",
  null
  
)

export default component.exports